import { Goal, Service, Partner, BasisType } from "@raskrask-dk/raskrask-utils";
import type {IBookableSchedulesDTO} from "..";

export interface ISchedules {
  goals: Goal[];
  services: Service[];
  partners: Partner[];
}

export interface IBookableAssembler {
  addSchedules(dtos: IBookableSchedulesDTO, basisType: BasisType): ISchedules;
  createSchedules(dtos: IBookableSchedulesDTO, basisType: BasisType): ISchedules;
  schedules(): ISchedules;
}

export const emptyDTOSchedules: IBookableSchedulesDTO = {
  goals: {
    byId: {},
    allIds: [],
  },
  services: {
    byId: {},
    allIds: [],
  },
  partners: {
    byId: {},
    allIds: [],
  },
};

export const emptyDomainSchedules: ISchedules = {
  goals: [],
  services: [],
  partners: [],
};
